<div *ngIf="report">
      
    <div [style]="styles.header.page">
      <div [style]="styles.header.text"><b>YOUR STYLE EXPRESSION</b></div>
  
      <div [style]="styles.header.line"></div>
    </div>
  
    <div [style]="styles.container_padding">
          
      <p [style]="styles.paragraph">Your most used expression is
        <span [style]="styles.highlight">{{ report.styleExpression }}</span>.</p>
  
      <p [style]="styles.paragraph" [innerHtml]="html"></p>
  
    </div>
  
  </div>